module.exports = {"sld:ColorMapEntry":[{"quantity":-999,"color":"#FFFFFF","label":"NO DATA"},{"quantity":0,"color":"#D7D7D7","label":"0"},{"quantity":0.001,"color":"#198CDB","label":"<=0.35"},{"quantity":0.03,"color":"#91E3AD","label":"0.35 - 0.98"},{"quantity":0.06,"color":"#DEFFB0","label":"0.98 - 1.79"},{"quantity":0.01,"color":"#FFE68C","label":"1.79 - 2.75"},{"quantity":9,"color":"#FF9982","label":"2.75 - 3.67"},{"quantity":12,"color":"#FF4D30","label":"3.67 - 6.66"}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/city_mme_1981_2016_lcr_80_rice.json
// module id = UAjg
// module chunks = 171